/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './support-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-support-page',
  template
})
export class SupportPageComponent {
}
